export default __webpack_public_path__ + "static/media/221.a74c3acb.jpg";